// AdminPages.jsx — re-exports all admin page components for use in App.jsx routes.
import React from 'react';
import AdminChats from '../AdminChats/AdminChats.jsx';
import AdminOrderDetails from '../AdminOrderDetails/AdminOrderDetails.jsx';

// ─── Shell helper ─────────────────────────────────────────────────────────────
function AdminPageShell({ className, title, children }) {
    return (
        <div className={`admin-page ${className || ''}`.trim()}>
            {children || (
                <div className="admin-placeholder">
                    <h1>{title || 'Coming Soon'}</h1>
                    <p>This admin section is being prepared.</p>
                </div>
            )}
        </div>
    );
}

// ─── Dashboard ────────────────────────────────────────────────────────────────
export function AdminDashboardPage() {
    return <AdminPageShell className="admin-page-dashboard" title="Dashboard" />;
}

// ─── Product pages — separate files ──────────────────────────────────────────
export { default as AdminProductsPage }   from '../AdminManageProducts/AdminManageProducts';
export { default as AdminCategoriesPage } from '../AdminManageCategories/AdminManageCategories';
export { default as AdminSubcategoriesPage } from '../AdminManageSubcategories/AdminManageSubcategories';
export { default as AdminSubmenusPage } from '../AdminManageSubmenus/AdminManageSubmenus';
export { default as AdminAttributesPage } from '../AdminManageAttributes/AdminManageAttributes';
export { default as AdminInventoryPage }  from '../AdminManageInventory/AdminManageInventory';

// ─── Order pages ──────────────────────────────────────────────────────────────
export function AdminOrdersPage() {
    return <AdminPageShell className="admin-page-orders" title="Order List" />;
}

export function AdminOrderDetailsPage() {
    return <AdminOrderDetails />;
}

// ─── Promotions ───────────────────────────────────────────────────────────────
// AdminPromotionsPage is kept as a named export so App.jsx doesn't break.
// The real Promotions page is imported directly in App.jsx as AdminPromotions.
export { default as AdminPromotionsPage } from '../AdminPromotions/AdminPromotions';

// AdminPromotionDetailsPage stub — App.jsx imports this name but the actual
// route uses <PromotionDetails /> directly, so this just needs to exist without erroring.
export function AdminPromotionDetailsPage() {
    return <AdminPageShell className="admin-page-promotion-details" title="Promotion Details" />;
}

// ─── Chats ────────────────────────────────────────────────────────────────────
export function AdminChatsPage() {
    return <AdminChats />;
}

// ─── Reports / Settings (placeholders) ───────────────────────────────────────
export function AdminReportsPage() {
    return <AdminPageShell className="admin-page-reports" title="Reports" />;
}

export function AdminSettingsPage() {
    return <AdminPageShell className="admin-page-settings" title="Settings" />;
}
